/**
 * Route copy for `src/routes/versions` (keys: `routes.versions.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  versionsBuiltPage: {
    yes: 'yes',
    no: 'no',
    yesWorkerWaiting: 'yes — a new worker is waiting for the next reload',
    versionsBuild: 'Versions & Build',
    pubsocialnetKarexiaBuildProvenanceForDev: 'PubSocialNet · Karexia — build provenance for dev / QA / prod parity.',
    checking: 'Checking…',
    reCheck: 'Re-check',
    buildFingerprintCompareAcrossEnvironment: 'Build fingerprint (compare across environments)',
    copied: 'Copied ✓',
    copy: 'Copy',
    identicalOnDevQaAndProd: 'Identical on dev, QA and prod ⇒ all three run the same artifact. Only the',
    labelAndConfigBelowDifferPer: 'label and config below differ per deployment.',
    servedArtifactVsThisPage: 'Served artifact vs this page',
    upToDate: 'Up to date',
    stale: 'Stale',
    undetermined: 'Undetermined',
    startedVersionThisBundle: 'Started version (this bundle)',
    servedVersionVersionJson: 'Served version (version.json)',
    servedCommit: 'Served commit',
    servedBuild: 'Served build',
    theCdnServesANewerArtifact: 'The CDN serves a newer artifact than the one loaded in this tab — typically an',
    stillCachedDeploymentWithoutAnEdge: 'still cached (deployment without an edge cache purge) or a tab opened before the release.',
    reloading: 'Reloading…',
    reloadTheLatestVersion: 'Reload the latest version',
    isOnlyEmittedAtBuildTime: 'is only emitted at build time (absent in the development server).',
    frontEndBuild: 'Front-end build',
    version: 'Version',
    buildDateTime: 'Build date & time',
    buildTimestampIso: 'Build timestamp (ISO)',
    gitCommit: 'Git commit',
    gitCommitFull: 'Git commit (full)',
    gitBranch: 'Git branch',
    commitDate: 'Commit date',
    workingTree: 'Working tree',
    runtimeConfigurationPerEnvironment: 'Runtime configuration (per environment)',
    configJsonErrorCfgerr: 'config.json error: {{cfgErr}}',
    environment: 'Environment',
    apiBaseUrl: 'API base URL',
    websocketUrl: 'WebSocket URL',
    keycloakRealm: 'Keycloak realm',
    keycloakAuthority: 'Keycloak authority',
    keycloakClient: 'Keycloak client',
    loadingConfig: 'Loading config…',
    backEndApiHealth: 'Back-end (API /health)',
    unreachableHealtherr: 'unreachable: {{healthErr}}',
    status: 'Status',
    apiVersion: 'API version',
    serverTime: 'Server time',
    uptime: 'Uptime',
    redisRateLimiting: 'Redis (rate limiting)',
    checkingBackend: 'Checking backend…',
    downstreamServicesApiHealthServices: 'Downstream services (API /health/services)',
    totalCountHealthy: '/{{total_count}} healthy',
    unreachableServiceserr: 'unreachable: {{servicesErr}}',
    noServiceDeclared: 'No service declared.',
    service: 'Service',
    status2: 'Status',
    latency: 'Latency',
    circuit: 'Circuit',
    serverReadingV: 'Server reading: {{v}}',
    checkingServices: 'Checking services…',
    serviceWorkerOfflineCache: 'Service worker (offline cache)',
    reading: 'Reading…',
    notSupportedByThisBrowser: 'Not supported by this browser.',
    saved: 'Saved',
    active: 'Active',
    updatePending: 'Update pending',
    scope: 'Scope',
    checkedOnVRenderedOnV2: 'Checked on {{v}} · rendered on {{v2}}',
  },
};

export default en;
